import React from 'react';
import { AIBadge } from '../../AiBadge';
import { motion } from 'framer-motion';
import { HomeCard } from '../HomeCard';
import { UiTag } from '../../UiTag';
import SparkleIcon from '../../../icons/SparkleIcon';
import { JobCardV2, type JobCardV2Job } from '../jobs/JobCardV2';
import TrendingIcon from '../../../icons/TrendingIcon';
import { Button } from 'antd';

const jobListings: JobCardV2Job[] = [
  {
    title: 'Civil Engineer',
    company: 'Dribble · Hybrid',
    postedDate: 'Posted on 1 day ago',
    location: 'Australia',
    salary: '$30K-$435K',
    daysRemaining: '4 Days Remaining',
    logo: 'https://c.animaapp.com/mibc0aags5LdA5/img/employers-logo-1.svg',
    logoBg: 'bg-[#1877f2]',
    featured: true,
    quickApply: true,
  },
  {
    title: 'Diagnostic Medical Sonographer',
    company: 'Dribble · Hybrid',
    postedDate: 'Posted on 1 day ago',
    location: 'Australia',
    salary: '$30K-$735K',
    daysRemaining: '4 Days Remaining',
    logo: 'https://c.animaapp.com/mibc0aags5LdA5/img/employers-logo-3.svg',
    logoBg: 'bg-[#ff4500]',
    featured: true,
    quickApply: true,
  },
  {
    title: 'Marketing Manager',
    company: 'Dribble · Hybrid',
    postedDate: 'Posted on 1 day ago',
    location: 'Australia',
    salary: '$30K-$1435K',
    daysRemaining: '4 Days Remaining',
    logo: 'https://c.animaapp.com/mibc0aags5LdA5/img/employers-logo-2.svg',
    logoBg:
      '[background:radial-gradient(50%_50%_at_61%_105%,rgba(140,58,170,0)_64%,rgba(140,58,170,1)_100%),radial-gradient(50%_50%_at_13%_100%,rgba(250,143,33,1)_9%,rgba(216,45,126,1)_78%)]',
    featured: true,
    quickApply: true,
  },
  {
    title: 'Product Designer',
    company: 'Stripe · Remote',
    postedDate: 'Posted on 2 days ago',
    location: 'United States',
    salary: '$80K-$180K',
    daysRemaining: '6 Days Remaining',
    logo: 'https://c.animaapp.com/mibc0aags5LdA5/img/employers-logo.svg',
    logoBg: 'bg-gray-scale50',
    featured: true,
    quickApply: true,
  },
];

export const JobListingsSection = (): JSX.Element => {
  return (
    <section className="flex flex-col w-full items-center justify-center gap-1 py-20 bg-white">
      <div className="flex flex-col w-full items-start gap-10">
        <div className="flex flex-col w-full items-start gap-8 px-8 py-0">
          <motion.div
            className="flex flex-col items-center gap-12 w-full"
            initial={{ scale: 0.5 }}
            whileInView={{ scale: 1 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.8, ease: 'easeOut' }}>
            <div className="flex flex-col max-w-[768px] items-center gap-3">
              <div className="flex flex-col items-center gap-3 w-full">
                <div className="inline-flex items-start">
                  <div className="inline-flex items-center gap-3 pl-1 pr-2.5 py-1 rounded-2xl">
                    <div className="inline-flex items-center">
                      <AIBadge title="Smart AI Search" />
                    </div>
                  </div>
                </div>

                <h2 className="m-0 w-full font-sans font-semibold text-[36px] leading-[44px] tracking-[-0.02em] text-center text-gray-900">
                  <span>Search less&nbsp;</span>
                  <span className="text-primary">Discover</span>
                  <span>&nbsp;more</span>
                </h2>
              </div>

              <p className="m-0 max-w-[656px] font-sans text-[20px] leading-[30px] tracking-normal font-light text-center text-gray-600">
                Our AI matches you with opportunities that align with your skills, experience, and
                career goals.
              </p>
            </div>
          </motion.div>
        </div>

        <motion.div
          className="flex flex-col md:flex-row w-full gap-4 items-center md:items-start"
          initial={{ opacity: 0, y: 32 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, amount: 0.55 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}>
          {/* LEFT CARD */}
          <HomeCard variant="compact" className="flex-shrink-0 md:!w-[317px] w-full">
            <div className="flex flex-col gap-3 w-full">
              <div className="font-sans text-[18px] leading-[28px] font-medium text-midnight-900">
                Quick Filters
              </div>
              <div className="flex flex-col gap-2">
                <div className="flex gap-[6px] flex-wrap">
                  <UiTag
                    label="Remote"
                    color="blue"
                    className="w-[72px] h-6 px-[10px] py-[2px] justify-center text-blue-700"
                  />
                  <UiTag
                    label="Full time"
                    color="purple"
                    className="h-6 px-[10px] py-[2px] justify-center text-purple-700"
                  />
                  <UiTag
                    label="Senior level"
                    color="green"
                    className="h-6 px-[10px] py-[2px] justify-center text-success-700"
                  />
                </div>
                <div className="flex gap-[6px] flex-wrap">
                  <UiTag
                    label="Startups"
                    color="pink"
                    className="h-6 px-[10px] py-[2px] justify-center text-pink-700"
                  />
                  <UiTag
                    label="Tech industry"
                    color="custom"
                    className="h-6 px-[10px] py-[2px] rounded-full justify-center text-[#053F3A] bg-[#F9F5FF]"
                  />
                </div>
              </div>
              <div className="w-full h-px bg-gray-200 mt-2" />
              <div className="font-sans text-[18px] leading-[28px] font-medium text-midnight-900">
                AI Suggestions
              </div>
              <UiTag
                label="Trending in your field"
                variant="gradient"
                className="w-[196px] h-6 px-[9px] py-[2px] gap-3 border border-[#2b7fff33] bg-gradient-to-r from-purple-50 to-blue-50 text-[#053F3A]"
                style={{ borderWidth: '0.67px' }}
                icon={<TrendingIcon className="w-[10px] h-[10px] text-[#6840c6] flex-shrink-0" />}
              />
              <UiTag
                label="Similar to your profile"
                variant="gradient"
                className="w-[196px] h-6 px-[9px] py-[2px] gap-3 border border-[#2b7fff33] bg-gradient-to-r from-purple-50 to-blue-50 text-[#053F3A]"
                style={{ borderWidth: '0.67px' }}
                icon={<SparkleIcon className="w-[10px] h-[10px] text-[#6840c6] flex-shrink-0" />}
              />
            </div>
          </HomeCard>

          {/* RIGHT COLUMN */}
          <div className="flex-1 flex flex-col gap-[12px] w-full">
            {jobListings.slice(0, 5).map((job, index) => (
              <JobCardV2 key={`${job.title}-${index}`} job={job} />
            ))}
            <Button
              className="h-12 px-5 py-3 gap-2 rounded-lg border border-[#F9F5FF] !bg-brand-50 text-ai-purple font-semibold"
              style={{ maxWidth: '100%' }}>
              Setup your profile
            </Button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
